export default "__VITE_ASSET__6592eb45__"